import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'form' ]

  update(event) {
    // Prevent Turbo from handling the response (we're just reading status)
    event.preventDefault()
    
    let code
    
    // Turbo format: event.detail.fetchResponse.response
    if (event.detail?.fetchResponse?.response) {
      code = event.detail.fetchResponse.response.status
    }
    
    // Created  201 : answer saved
    // Accepted 202 : all questions answered (enable submit)
    if (code === 202) {
      this.formTarget.disabled = false
      this.formTarget.querySelectorAll('[type="submit"]').forEach((submit) => {
        submit.disabled = false
      })
      console.log('✓ All questions answered - submit button enabled')
    } else if (code === 201) {
      console.log('✓ Answer saved - waiting for more answers')
    } else {
      console.warn('⚠️ Unexpected status code:', code)
    }
  }
}
